export default class ShopSelection {
	constructor() {
		document.addEventListener('bless', (e) => {
			this.init(e.detail.element);
		});
	}

	init(container) {
		const shopSelects = container.querySelectorAll('[data-shop-selection]');
		shopSelects.forEach((shopSelect) => {
			const trigger = shopSelect.querySelector('[data-shop-selection-button]');
			trigger.addEventListener('click', () => {
				shopSelect.classList.toggle('is-open');
			});
		});
	}
}